import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SendInfoService {
    private info: Subject<Boolean> = new BehaviorSubject<Boolean>(false);

    get info$() {
        return this.info.asObservable();
    }

    sendInfo(bool: Boolean) {
        this.info.next(bool);
    }

}